<template>
  <div class="w-full flex pt-5">
    <div :class="{ 'is-unread': notification.isUnread }" />

    <div class="mr-4">
      <request-for-proposal-notification-icon :status="status" />
    </div>

    <div class="w-full">
      <div class="flex justify-between header">
        <span>{{ $formatShortDate(notification.createdAt) }}</span>
        <span>{{ $formatTime(notification.createdAt) }}</span>
      </div>

      <div class="text">
        <p>You've been assigned to <strong>{{ notification.requestForProposal.name }}</strong></p>
        <a
          class="block cursor-pointer underline my-2"
          @click="gotoRequestForProposal"
        >View Request For Proposal</a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { RequestForProposalNotificationIcon } from '@/components/icons'

dayjs.extend(relativeTime)

export default {
  components: {
    RequestForProposalNotificationIcon
  },

  props: {
    notification: {
      type: Object,
      required: false,
      default: null
    }
  },

  computed: {
    status () {
      if (!this.notification.requestForProposal.dueDate) return 'default'

      const diff = this.getDiffForDueDate(this.notification.requestForProposal.dueDate)

      if (diff > 0) {
        return 'default'
      } else if (diff === 0) {
        return 'today'
      } else {
        return 'overdue'
      }
    },
  },

  methods: {
    getDiffForDueDate (dueDate) {
      const today = dayjs().startOf('day')
      const due = dayjs(dueDate).startOf('day')
      const diff = due.diff(today, 'day')
      return diff
    },

    gotoRequestForProposal () {
      this.$router.push({
        name: 'EditRequestForProposal',
        params: {
          id: this.notification.notifiableId
        }
      }).catch(() => {})
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.is-unread {
  min-width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-top: 10px;
  margin-right: 8px;
  background-color: #2e76bc;
}

.header {
  color: rgb(97, 91, 91);
}

.text {
  padding: 10px 0 10px 0 ;
  max-width: 415px;
  line-height: 1.5;
}
</style>
